module.exports = __webpack_public_path__ + "static/media/gameBg.18230565.jpg";